import {SETTINGS} from "../config/common.settings";

const transportIconMap: { [key: string]: string } = {
  [SETTINGS.TRANSPORT_TYPES[0].value]: 'plane',
  [SETTINGS.TRANSPORT_TYPES[1].value]: 'car-front',
  [SETTINGS.TRANSPORT_TYPES[2].value]: 'sailboat',
  [SETTINGS.TRANSPORT_TYPES[3].value]: 'tram-front'
};

export function getTransportIcon(typeOfVehicle: string): string {
  return transportIconMap[typeOfVehicle];
}


